<template>
  <div class="vx-col w-full mb-base" ref="popupContainer">
    <vs-popup :active.sync="showNetlinkPopup" :title="society_name ? 'Modification d\'un Netlink: ' + society_name + ' (' + provider_name + ')' : 'Modification d\'un Netlink'">
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Lien acheté</label>
			<div class="flex">
				<vs-input
					class="w-full"
					placeholder="Lien acheté"
					v-model="modifiedNetlink.url_bought"
					:style="styleValidator('url_bought')"
					@change="validateOne(modifiedNetlink.url_bought, 'url_bought')"
				/>
				<vx-tooltip v-if="validators['url_bought'] && validators['url_bought'].errText !== ''" :text="errText('url_bought')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Landing page</label>
			<div class="flex">
				<vs-input
					class="w-full"
					placeholder="Landing page"
					v-model="modifiedNetlink.landing_page"
					:style="styleValidator('landing_page')"
					@change="validateOne(modifiedNetlink.landing_page, 'landing_page')"
				/>
				<vx-tooltip v-if="validators['landing_page'] && validators['landing_page'].errText !== ''" :text="errText('landing_page')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Statut</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.status"
					class="w-full select-medium mr-2"
					placeholder="Statut"
					:style="styleValidator('status')"
					@change="validateOne(modifiedNetlink.status, 'status')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in netlinkStatus"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['status'] && validators['status'].errText !== ''" :text="errText('status')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Type ancre</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.anchor_type"
					class="w-full select-medium mr-2"
					placeholder="Type ancre"
					:style="styleValidator('anchor_type')"
					@change="validateOne(modifiedNetlink.anchor_type, 'anchor_type')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in anchorTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['anchor_type'] && validators['anchor_type'].errText !== ''" :text="errText('anchor_type')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Type lien</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.link_type"
					class="w-full select-medium mr-2"
					placeholder="Type lien"
					:style="styleValidator('link_type')"
					@change="validateOne(modifiedNetlink.link_type, 'link_type')"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in netlink_types"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['link_type'] && validators['link_type'].errText !== ''" :text="errText('link_type')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div v-if="modifiedNetlink" class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Prix</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedNetlink.price"
					:style="styleValidator('price')"
					@change="validateOne(modifiedNetlink.price, 'price')"
				/>
				<vx-tooltip v-if="validators['price'] && validators['price'].errText !== ''" :text="errText('price')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div v-if="isRecurringLink(modifiedNetlink.link_type)" class="vx-col sm:w-1/3 w-full" style="white-space: nowrap !important;">
		  	<label for="" class="vs-select--label">Renouvellement</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.renew_duration"
					class="w-full select-medium mr-2"
					:style="styleValidator('renew_duration')"
					@change="validateOne(modifiedNetlink.renew_duration, 'renew_duration')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in renewDurations"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['renew_duration'] && validators['renew_duration'].errText !== ''" :text="errText('renew_duration')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
		<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
			<label for="" class="vs-select--label">Periode</label>
		<vx-input-group class="w-full bottom">
					<template slot="prepend">
					<div class="prepend-text bg-primary">
						<span class="flex"
						><vs-icon icon="calendar_today" size="small"></vs-icon
						></span>
					</div>
					</template>
					<flat-pickr
					class="w-full"
					v-model="modifiedNetlink.period_date"
					placeholder="Date de fin"
					:config="configDatePicker"
					/>
				</vx-input-group>
				</div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button color="primary" class="mt-2" @click="saveModifiedNetlink()">Enregistrer Netlink</vs-button>
        </div>
      </div>
    </vs-popup>
    <vx-card v-if="$acl.check('accountmanager')" class="mb-1">
		<div id="filterCardNet">
      	<div class="vx-row">
		  	<div class="vx-col"><vs-button
				class="btn"
				type="filled" icon-pack="feather" icon-after :icon="showFilters?'icon-chevron-down':'icon-chevron-right'"
				@click="toogleFilter()">Filtres</vs-button></div>
			<div class="vx-col mb-2">
				<vs-button
					icon-pack="feather" icon="icon-plus-circle"
					color="primary"
					@click="$router.push({ name: 'new_entity' })"
				>Nouveau Netlink
				</vs-button>
			</div>
        	<vs-spacer />
			<div class="vx-col mb-2">
				<vs-button
				ref="import-netlink-button"
					icon-pack="feather" icon="icon-upload-cloud"
					color="dark"
					@click="goToImportNetlinkPage()"
				>Importer des netlinks
				</vs-button>
			</div>
			<div class="vx-col mb-2">
				<vs-button
					icon-pack="feather" icon="icon-download-cloud"
					color="dark"
					@click="exportData(netlink)"
				>Exporter
				</vs-button>
			</div>
			<div class="vx-col mb-2">
				<vs-button
					icon-pack="feather" icon="icon-download-cloud"
					color="dark"
					@click="exportData(currentTab == 0 ? displayedNetlink : 'tabGestion')"
				>Exporter la sélection
				</vs-button>
			</div>
		</div>
	  	<div class="vx-row" v-if="showFilters" style="padding-left: 20px;">
		  <div v-if="currentTab == 0">
      		<div class="vx-row">
				<div class="vx-col px-1 mb-2" v-if="activeUser.role == 1">
					<vs-select
						v-model="societyFilter"
						class="w-full select-large"
						placeholder="Client"
						autocomplete
					>
						<vs-select-item
						v-if="activeUser.role == 1"
						value=""
						text="Client"
						class="w-full"
						/>
						<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in userSocietiesOptions"
						class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-input class="inputx" placeholder="N° de contrat" v-model="contractFilter" />
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-input class="inputx" placeholder="Prestataire" v-model="providerFilter" />
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-input class="inputx" placeholder="Lien ou landing page" v-model="linkNameFilter" />
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-select
					autocomplete
					v-model="anchorFilter"
					class="w-full select-large"
					placeholder="Type Ancre"
				>
					<vs-select-item
					value=""
					text="Type Ancre"
					class="w-full"
					/>
					<vs-select-item
					:key="index"
					:value="item.value + 1"
					:text="item.text"
					v-for="(item, index) in anchorTypes"
					class="w-full"
					/>
				</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-select
					autocomplete
					v-model="linkFilter"
					class="w-full select-large"
					placeholder="Type Lien"
				>
					<vs-select-item
					value=""
					text="Type Lien"
					class="w-full"
					/>
					<vs-select-item
					:key="index"
					:value="item.id"
					:text="item.name"
					v-for="(item, index) in netlink_types"
					class="w-full"
					/>
				</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-select
					autocomplete
					v-model="statusFilter"
					class="w-full select-large"
					placeholder="Statut"
					multiple
				>
					<vs-select-item
					:key="index"
					:value="item.value"
					:text="item.text"
					v-for="(item, index) in netlinkStatus"
					class="w-full"
					/>
				</vs-select>
				</div>
				<!-- <div class="vx-col mb-2 px-1">

				<vx-input-group class="w-full bottom">
				<template slot="prepend">
					<div class="prepend-text bg-primary">
					<span class="flex"
						><vs-icon icon="calendar_today" size="small"></vs-icon
					></span>
					</div>
				</template>
				<flat-pickr
					class="w-full"
					v-model="dateFromFilter"
					placeholder="Date de début"
					:config="configDatePicker"
				/>
				</vx-input-group>

				</div>
				<div class="vx-col mb-2 px-1">

				<vx-input-group class="w-full bottom">
					<template slot="prepend">
					<div class="prepend-text bg-primary">
						<span class="flex"
						><vs-icon icon="calendar_today" size="small"></vs-icon
						></span>
					</div>
					</template>
					<flat-pickr
					class="w-full"
					v-model="dateToFilter"
					placeholder="Date de fin"
					:config="configDatePicker"
					/>
				</vx-input-group>
				</div> -->
				<div class="vx-col mb-2 px-1">
				<!-- DATE -->
				<vx-input-group class="w-full bottom">
					<template slot="prepend">
					<div class="prepend-text bg-primary">
						<span class="flex"
						><vs-icon icon="calendar_today" size="small"></vs-icon
						></span>
					</div>
					</template>
					<flat-pickr
					class="w-full"
					v-model="periodToFilter"
					placeholder="Date de fin"
					:config="configDatePicker"
					/>
				</vx-input-group>
				<!-- /DATE -->
				</div>
				<div class="vx-col mb-2">
				<vs-button
					color="primary"
					@click="searchAndDisplay"
				>Recherche        </vs-button>

				</div>
				<vx-tooltip text="Effacer les filtres" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
				<vs-button class ="ml-2" type="line" style="border: 0px;" @click="clearAll()" color="danger" icon="clear"></vs-button>
			</vx-tooltip>
			<br></br>

			</div>
			<div class="vx-row mt-2" v-if="displayedNetlink.length > 0">
				<div class="vx-col">
				<strong>Nombre de résultats : {{ displayedNetlink.length }}</strong>
				</div>
			</div>
		  </div>
				<GestionNetLinkingFilter v-else :userSocietiesOptions = "userSocietiesOptions" @gestionFilterReq="gestionFilterReq" :optionList="optionList" :listLength="listContracts.length" :refreshKey="refreshKey"/>
		</div>
	</div>
	</vx-card>

	<vx-card v-else>
		<div id="filterCardNet">
		<div class="vx-row">
		  	<div class="vx-col">
				<vs-button @click="toogleFilter()">Filtres</vs-button></div>
		</div>
	  	<div class="vx-row" v-if="showFilters" style="padding-left: 20px;">
		  <div v-if="currentTab == 2">
      		<div class="vx-row">
				<div class="vx-col px-1 mb-2" v-if="activeUser.role == 1">
					<vs-select
						v-model="societyFilter"
						class="w-full select-large"
						placeholder="Client"
						autocomplete
					>
						<vs-select-item
						v-if="activeUser.role == 1"
						value=""
						text="Client"
						class="w-full"
						/>
						<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in userSocietiesOptions"
						class="w-full"
						/>
					</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-input class="inputx" placeholder="N° de contrat" v-model="contractFilter" />
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-input class="inputx" placeholder="Prestataire" v-model="providerFilter" />
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-input class="inputx" placeholder="Lien ou landing page" v-model="linkNameFilter" />
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-select
					autocomplete
					v-model="anchorFilter"
					class="w-full select-large"
					placeholder="Type Ancre"
				>
					<vs-select-item
					value=""
					text="Type Ancre"
					class="w-full"
					/>
					<vs-select-item
					:key="index"
					:value="item.value + 1"
					:text="item.text"
					v-for="(item, index) in anchorTypes"
					class="w-full"
					/>
				</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-select
					autocomplete
					v-model="linkFilter"
					class="w-full select-large"
					placeholder="Type Lien"
				>
					<vs-select-item
					value=""
					text="Type Lien"
					class="w-full"
					/>
					<vs-select-item
					:key="index"
					:value="item.id"
					:text="item.name"
					v-for="(item, index) in netlink_types"
					class="w-full"
					/>
				</vs-select>
				</div>
				<div class="vx-col px-1 mb-2">
				<vs-select
					autocomplete
					v-model="statusFilter"
					class="w-full select-large"
					placeholder="Statut"
					multiple
				>
					<vs-select-item
					:key="index"
					:value="item.value"
					:text="item.text"
					v-for="(item, index) in netlinkStatus"
					class="w-full"
					/>
				</vs-select>
				</div>
				<div class="vx-col mb-2 px-1">
				<!-- DATE -->
				<vx-input-group class="w-full bottom">
				<template slot="prepend">
					<div class="prepend-text bg-primary">
					<span class="flex"
						><vs-icon icon="calendar_today" size="small"></vs-icon
					></span>
					</div>
				</template>
				<flat-pickr
					class="w-full"
					v-model="dateFromFilter"
					placeholder="Date de début"
					:config="configDatePicker"
				/>
				</vx-input-group>
				<!-- /DATE -->
				</div>
				<div class="vx-col mb-2 px-1">
				<!-- DATE -->
				<vx-input-group class="w-full bottom">
					<template slot="prepend">
					<div class="prepend-text bg-primary">
						<span class="flex"
						><vs-icon icon="calendar_today" size="small"></vs-icon
						></span>
					</div>
					</template>
					<flat-pickr
					class="w-full"
					v-model="dateToFilter"
					placeholder="Date de fin"
					:config="configDatePicker"
					/>
				</vx-input-group>
				<!-- /DATE -->
				</div>
				<div class="vx-col mb-2">
				<vs-button
					color="primary"
					@click="searchAndDisplay"
				>Recherche        </vs-button>
				</div>
			</div>

		  </div>
			<GestionNetLinkingFilter v-else :userSocietiesOptions = "userSocietiesOptions" @gestionFilterReq="gestionFilterReq" :optionList="optionList" :listLength="listContracts.length" :refreshKey="refreshKey"/>
		</div>
	</div>
	</vx-card>

    <!-- <vx-card></vx-card> -->
    <vx-card style="max-height:79vh; overflow: auto;">
		<div v-if = "isLoading" class="flex justify-center items-center h-full">
			<CircularLoader />
		</div>
		<vs-tabs v-model="currentTab" v-else>

			<vs-tab label="Netlinking">
				<div v-if = "isNetlinkLoading">
					<circular-loader/>
				</div>
				<NetlinkTable
				v-else
					:netlink="displayedNetlink"
					:listResult="listNetlinksId"
					:key="netlinkRefreshKey"
					@delete-line="removeLine($event)"
					@modify-netlink="modifyNetlink($event)"
					@show-contract-popup="displayContractPopup($event)"
					@show-society-popup="displaySocietyPopup($event)"
					@refresh-netlink = "searchAndDisplay()"
				/>
			</vs-tab>
			<vs-tab label="Gestion mensuelle">
				Hors service
				<!-- <div v-if = "isGestionLoading">
					<circular-loader/>
				</div>
				<GestionConsultantsNetlinkingTable
				v-else
					@getData="filterContract()"
					:refreshKey="refreshKey"
					:selectedDate="filterFields.start_date"
					:contracts="cloneListContracts"
					@refresh-key="refreshKey++"
					@refresh-data="filterContract()"
					@modify-contract="modifyContract($event)"
					@display-contract="displayContractPopup($event)"
				/> -->
			</vs-tab>
		</vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import Validator from "@/entities/Validator";
import NetlinkTable from "@/components/tables/NetlinkTable";
import GestionConsultantsNetlinkingTable from "@/components/tables/GestionConsultantsNetlinkingTable";
import Netlink from "@/entities/Netlink";
import store from "@/store/store";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import XLSX from "xlsx";
import FilterCard from "@/views/filters/FilterCard";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import fiterListMixins from "@/mixins/filterListMixins.js";
import "flatpickr/dist/flatpickr.css";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";
import GestionNetLinkingFilter from "@/views/filters/GestionNetLinkingFilter";
import CircularLoader from "../../components/widgets/loader/CircularLoader.vue";

export default {
	name: "NetlinkDashboard",
	mixins: [utilsMixin, dbFieldConvertorMixin, fiterListMixins],
	components: {
		FilterCard,
		GestionConsultantsNetlinkingTable,
		monthSelect,
		NetlinkTable,
		flatPickr,
		VxTooltip,
		GestionNetLinkingFilter,
		CircularLoader,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			isLoading: true,
			isNetlinkLoading: true,
			anchorFilter: "",
			contractFilter: "",
			dateFromFilter: "",
			dateToFilter: "",
			periodToFilter: "",
			linkNameFilter: "",
			providerFilter: "",
			societyFilter: "",
			statusFilter: [],
			activeFilter: false,
			linkFilter: "",
			anchorFilterOn: false,
			contractFilterOn: false,
			dateFromFilterOn: false,
			dateToFilterOn: false,
			periodToFilterOn: false,
			linkNameFilterOn: false,
			providerFilterOn: false,
			societyFilterOn: false,
			statusFilterOn: false,
			activeFilterOn: false,
			linkFilterOn: false,
			cloneListContract: [],
			netlinkRefreshKey: 0,
			// netlink: [],
			userSocietiesOptions: [],
			displayedNetlinkFull: [],
			displayedNetlink: [],
			modifiedNetlink: Netlink.getFormFields(),
			showNetlinkPopup: false,
			showFilters: true,
			netlinkStatus: [
				{ text: "Actif", value: 0 },
				{ text: "En\u00a0attente", value: 1 },
				{ text: "Refusé", value: 2 },
				{ text: "Terminé", value: 3 },
				{ text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			anchorTypes: [
				{ text: "Brand et Générique", value: 0 },
				{ text: " Semi optimisée", value: 1 },
				{ text: "Générique", value: 2 },
				{ text: "Non optimisée", value: 3 },
				{ text: "Optimisée", value: 4 },
			],
			linkTypes: [
				{ text: "Lien HP", value: 0 },
				{ text: "Article Sponsorisé", value: 1 },
				{ text: "NDD expiré en redirection", value: 2 },
				{ text: "NDD expiré mini-site", value: 3 },
				{ text: "Lien Sponsorisé", value: 4 },
				{ text: "Forum", value: 5 },
				{ text: "Annuaire", value: 6 },
				{ text: "Article", value: 7 },
				{ text: "Média Référent", value: 11 },

				{ text: "RP digitale", value: 12 },
			],
			renewDurations: [
				{ text: "A vie", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Annuel", value: 12 },
			],
			selectedContract: null,
			// selectedSociety: null,
			showSocietyPopup: false,
			showContractPopup: false,
			validators: {},
			check: true,
			listNetlinksId: "",
			society_name: null,
			provider_name: null,

			//Gestion mensuelle
			allContracts: [],
			listContracts: [],
			cloneListContracts: null,
			isGestionLoading: false,
			accountmanagerFilter: null,
			contractNumberFilter: null,
			gestionSocietyFilter: null,
			gestionStatusFilter: [],
			accountmanagerOptions: [],
			contractStatusOptions: [
				{ text: "Actif", value: 1 },
				{ text: "A\u00a0Valider", value: 2 },
				{ text: "En\u00a0pause", value: 3 },
				{ text: "Terminé", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			dateFilter: null,
			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			refreshKey: 0,
			currentTab: 0,
			optionList: {},
		};
	},
	created() {
		let today = new Date(Date.now());
		this.dateFilter = `${today.getMonth() + 1}/${today.getFullYear()}`;
		this.$store.dispatch("getAllCollaborators");
		this.accountmanagerFilter = VueCookies.get("userInfo").id;
		this.createSocietyList();
		this.getAllNetlink();
		this.getAllNetlinkTypes();
		this.$store.dispatch("getAllProviders");
		this.getAllPurchases();
		this.getAllSociety();
		this.filterContract();
		this.accountmanagerOptions = this.sortABC(
			this.allCollaborators.filter((collaborator) =>
				[3, 6, 9].includes(collaborator.type)
			),
			"firstname"
		);

		this.optionList = {
			netlinkStatus: this.contractStatusOptions,
			anchorTypes: this.anchorTypes,
			linkTypes: this.linkTypes,
			dateOption: {
				configDatePicker: this.configDatePicker,
				dateFromFilter: this.$route.query.targetStartDate,
				dateToFilter: this.$route.query.targetEndDate,
			},
		};
		this.$store.dispatch("getAllMissions");
		this.$store.dispatch("getAllProducts");
		this.$store.dispatch("getAllProductsCategories");
	},
	mounted() {
		// this.displayedNetlink = this.displayNetlink(this.netlink)
		// store.dispatch("updateFilterCardHeight", document.getElementById("filterCard").clientHeight);
		// //console.log("mounted FILTER");
		// //console.log(document.getElementById("filterCard").clientHeight);
		// window.onresize = () => {
		// 	store.dispatch("updateFilterCardHeight", document.getElementById("filterCard").clientHeight);
		// };
		this.displayedNetlinkFull = this.displayNetlink(this.netlink);
		if (this.$route.query.targetContract) {
			this.contractFilter = this.$route.query.targetContract;
			this.societyFilter = this.$route.query.targetSociety
				? this.$route.query.targetSociety
				: "";
			this.dateFromFilter = this.$route.query.targetStartDate;
			this.dateToFilter = this.$route.query.targetEndDate;
		}
	},
	watch: {
		netlinkRefreshKey: function () {
			this.getAllNetlink();
			// this.searchAndDisplay();
		},
		showFilters: function (data) {
			//console.log("Filterheight", document.getElementById("filterCardNet").clientHeight, data);
			store.dispatch("updateFilterDown", data);
			store.dispatch(
				"updateFilterCardHeight",
				document.getElementById("filterCardNet").clientHeight
			);
			// //console.log("WIN NAV FILT FROM FILTER", this.windowHeigth, this.horizentalNavBarHeight, this.filterCardHeight);
			// store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.15*this.windowHeigth));
		},
		selectedUserSociety: function (data) {
			if (data && data.id) {
				this.societyFilter = data.id;
				this.$store.commit("SET_SELECTED_SOCIETY", data);
				//console.log("selectedSociety watch", data);
			}

			/*
			 * Clear data
			 * this.clearData()
			 * this.refreshData(this.apiLastUpdate)
			 */
		},
		netlink: function (data) {
			////console.log("netlink WATCH")
			this.displayedNetlink = [];
			this.displayedNetlinkFull = data;
			/*
			 * if(this.activeUser.role == 1) this.searchAndDisplay();
			 * if(this.activeUser.role == 2 && this.selectedUserSociety && this.selectedUserSociety.id){
			 * 	this.societyFilter = this.selectedUserSociety.id;
			 * 	this.societyFilterOn = true;
			 * 	this.searchAndDisplay();
			 * }
			 */
			this.searchAndDisplay();
			// this.displayedNetlink = this.displayNetlink(data);
		},
		societies: function () {
			this.createSocietyList();
		},
		anchorFilter: function () {
			if (this.anchorFilter == "") {
				this.anchorFilterOn = false;
			} else {
				this.anchorFilterOn = true;
			}
			//////console.log("anchorFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		contractFilter: function () {
			if (this.contractFilter == "") {
				this.contractFilterOn = false;
			} else {
				this.contractFilterOn = true;
			}
			//////console.log("contractFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		dateFromFilter: function () {
			if (this.dateFromFilter == "") {
				this.dateFromFilterOn = false;
			} else {
				this.dateFromFilterOn = true;
			}
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		dateToFilter: function () {
			if (this.dateToFilter == "") {
				this.dateToFilterOn = false;
			} else {
				this.dateToFilterOn = true;
			}
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		periodToFilter: function (data) {
			if (this.periodToFilter == "") {
				this.periodToFilterOn = false;
			} else {
				this.periodToFilterOn = true;
			}
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		linkNameFilter: function () {
			if (this.linkNameFilter == "") {
				this.linkNameFilterOn = false;
			} else {
				this.linkNameFilterOn = true;
			}
			//////console.log("linkNameFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		providerFilter: function () {
			if (this.providerFilter == "") {
				this.providerFilterOn = false;
			} else {
				this.providerFilterOn = true;
			}
			//////console.log("providerFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			// if(this.activeUser.role == 2 && this.societyFilterOn) this.searchAndDisplay()
		},
		societyFilter: function () {
			if (this.societyFilter == "") {
				this.societyFilterOn = false;
			} else {
				this.societyFilterOn = true;
			}
			//////console.log("societyFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		activeFilter: function () {
			this.activeFilterOn = true;
			//////console.log("activeFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		linkFilter: function () {
			if (this.linkFilter == "") {
				this.linkFilterOn = false;
			} else {
				this.linkFilterOn = true;
			}
			//////console.log("linkFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},
		statusFilter: function () {
			if (this.statusFilter == "") {
				this.statusFilterOn = false;
			} else {
				this.statusFilterOn = true;
			}
			//////console.log("statusFilter")
			// this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull) //A CHANGER
			if (this.activeUser.role == 2 && this.societyFilterOn)
				this.searchAndDisplay();
		},

		//Gestion mensuelle

		allCollaborators: function (data) {
			this.accountmanagerOptions = data
				.filter((collaborator) => [3, 6, 7, 9].includes(collaborator.type))
				.sort((a, b) => {
					return a["firstname"].localeCompare(b["firstname"]); //using String.prototype.localCompare()
				});
		},
		accountmanagerFilter: async function () {
			await this.filterContract();
		},
		currentTab: function (data) {
			if (data == 0) this.searchAndDisplay();
			this.refreshKey++;
		},
		dateFilter: async function () {
			await this.filterContract();
		},
		listContracts: function () {
			this.gestionFilterReq();
		},
		/*
		 * filterFields: function(data){
		 * 	data.
		 * 	this.cloneListContracts = this.listContracts[]
		 * }
		 */
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		filterRowNum: () => {
			return store.state.filterRowNum;
		},
		contracts: () => {
			return store.state.contracts_contracts_users;
		},
		filterFields: () => {
			return store.state.filterFields;
		},
		missions: () => {
			return store.state.missions;
		},
		netlink: () => {
			return store.state.netlink;
		},
		netlink_types: () => {
			return store.state.netlink_types;
		},
		providers: () => {
			return store.state.providers;
		},
		products: () => {
			return store.state.products;
		},
		products_categories: () => {
			return store.state.products_categories;
		},
		purchases: () => {
			return store.state.purchases;
		},
		societies: () => {
			return store.state.societies;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		selectedUserSociety: () => {
			return store.state.activeUserSociety;
		},

		//Gestion mensuelle

		allCollaborators: () => {
			return store.state.collaborators;
		},
	},
	methods: {
		clearAll() {
			this.anchorFilter = "";
			this.contractFilter = "";
			this.dateFromFilter = "";
			this.dateToFilter = "";
			this.periodToFilter = "";
			this.linkNameFilter = "";
			this.providerFilter = "";
			this.societyFilter = "";
			this.statusFilter = [];
			this.activeFilter = false;
			this.linkFilter = "";
			this.anchorFilterOn = false;
			this.contractFilterOn = false;
			this.dateFromFilterOn = false;
			this.periodToFilterOn = false;
			this.dateToFilterOn = false;
			this.linkNameFilterOn = false;
			this.providerFilterOn = false;
			this.societyFilterOn = false;
			this.statusFilterOn = false;
			this.activeFilterOn = false;
			this.linkFilterOn = false;
			this.accountmanagerFilter = null;
			this.contractNumberFilter = null;
			this.gestionSocietyFilter = null;
			this.searchAndDisplay();
		},
		toogleFilter() {
			this.showFilters = !this.showFilters;
		},
		isRecurringLink(link_type) {
			let foundIndex = this.netlink_types.findIndex(
				(row) => row.id == link_type
			);
			if (foundIndex >= 0) {
				if (this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},
		goToImportNetlinkPage() {
			this.setLoading(true, "import-netlink-button");
			this.$router.push({ name: "import_netlinks" });
		},
		createSocietyList() {
			if (this.activeUser.role == 1) {
				/*
				 *  let filledGSCAnalyticsSocieties = this.societies.filter(society => society.gsc_url != null && society.analytics_id != null)
				 * console.log("createSocietyList this.activeUser.role == 1", this.societies);
				 */
				this.userSocietiesOptions = this.societies;
			} else {
				this.$http
					.get(this.apiUrl + "usersSocieties/get/u/" + this.activeUser.id)
					.then((res) => {
						let listOfSociety = res.data.map(
							(user_societies) => user_societies.id
						);
						this.userSocietiesOptions = this.societies.filter((society) =>
							listOfSociety.includes(society.id)
						);
						/*
						 * this.societyFilter = this.userSocietiesOptions[0].id + 1
						 * this.societyFilterOn = true
						 */
					})
					.catch((err) => {
						////console.log(err)
					});
			}
		},
		/**
		 * Fetch all the purchases
		 */
		getAllPurchases() {
			this.$store.dispatch("getAllPurchases");
		},

		/**
		 * Fetch all the netlink
		 */
		async getAllNetlink() {
			this.isLoading = true;
			await Netlink.getAll();
			this.isLoading = false;
			// await this.$store.dispatch("getAllNetlink");
		},

		getAllNetlinkTypes() {
			this.$store.dispatch("getAllNetlinkTypes");
		},

		getAllSociety() {
			this.$store.dispatch("getAllSocieties");
		},

		getBudgetTotalNetlinking() {
			if (this.listContracts) {
				return this.convertInternationalNumberToFrenchCurrency(
					this.listContracts.reduce(
						(sum, e) => sum + Number(e.total_max_budget_netlink || 0),
						0
					)
				);
			}
			return this.convertInternationalNumberToFrenchCurrency(0);
		},

		getSocietyName(society_id) {
			let society_name = "";
			let society = this.societies.find((society) => society.id == society_id);
			society_name = society.name;
			return society_name;
		},

		getProviderName(provider_id) {
			let foundProvider = this.providers.findIndex(
				(provider) => provider.id == provider_id
			);
			if (foundProvider >= 0) {
				return this.providers[foundProvider].society;
			}
			return "";
		},

		removeLine(oneNetlink) {
			let netlinkToDelete = this.displayedNetlinkFull.find(
				(element) => element.id == oneNetlink.id
			);
			////console.log(netlinkToDelete)
			this.displayedNetlinkFull = this.displayedNetlinkFull.filter(function (
				element
			) {
				return element.id != oneNetlink.id;
			});
			this.displayedNetlink = this.displayedNetlinkFull;
			////console.log("removeLine")
		},

		modifyNetlink(netlink) {
			/*
			 * //console.log(netlink)
			 * Initialisation des données pour le popup
			 */
			this.society_name = null;
			this.modifiedNetlink = null; // Always reset data before assigning it
			this.modifiedNetlink = JSON.parse(JSON.stringify(netlink[0]));
			this.provider_name = netlink[0].provider_name;
			this.society_name = netlink[1];
			this.showNetlinkPopup = true;
		},

		renewNetlink(netlinkId) {
			this.$router.push({
				name: "new_entity",
				params: { netlinkId: netlinkId, newEntityForm: "renewnetlink" },
			});
		},
		/**
		 * Return true if a filter has been set
		 * @return {Boolean} - Is filter set ?
		 */
		isFilterSet() {
			//////console.log("isFilterSet BEGIN")

			/*
			 * if(store.state.activeUserSociety == null) {
			 *   this.societyFilterOn = false
			 * }else{
			 *   this.selectedSociety = store.state.activeUserSociety
			 *   this.societyFilterOn = true
			 * }
			 */
			if (
				this.linkFilterOn ||
				this.societyFilterOn ||
				this.anchorFilterOn ||
				this.linkNameFilterOn ||
				this.dateFromFilterOn ||
				this.dateToFilterOn ||
				this.contractFilterOn ||
				this.providerFilterOn
			)
				return true;
			return false;
		},

		/**
		 * Return list of filtered netlink A CHANGER
		 * @param {String} anchorFilterOn - Society is active?
		 * @param {String} linkNameFilterOn - Bought Link or Landing page
		 * @param {String} societyFilter - String to match in society name
		 * @param {String} linkFilterOn - Id of the commercial in charge of the project
		 * @return {List} - Societies' list filtered
		 */
		filterNetlink(netlink) {
			let netlinkList = [];

			let searchKeyList = {};
			// //console.log("this.societyFilter", this.societyFilter)
			this.contractFilterOn
				? (searchKeyList["contractFilter"] = this.contractFilter)
				: false;
			this.dateFromFilterOn
				? (searchKeyList["dateFromFilter"] = new Date(
						this.dateFromFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.dateToFilterOn
				? (searchKeyList["dateToFilter"] = new Date(
						this.dateToFilter.split("/").reverse().join("-")
				  ))
				: false;
			this.societyFilterOn
				? (searchKeyList["societyFilter"] = this.societyFilter + 1)
				: false;
			this.anchorFilterOn
				? (searchKeyList["anchorFilter"] = this.anchorFilter)
				: false;
			this.linkNameFilterOn
				? (searchKeyList["linkNameFilter"] = this.linkNameFilter)
				: false;
			this.linkFilterOn
				? (searchKeyList["linkFilter"] = parseInt(this.linkFilter) + 1)
				: false;
			this.providerFilterOn
				? (searchKeyList["providerFilter"] = this.providerFilter.toLowerCase())
				: false;

			if (this.dateToFilterOn)
				searchKeyList["dateToFilter"].setDate(
					searchKeyList["dateToFilter"].getDate() + 1
				);
			////console.log(netlink)
			for (let netlinkToFilter of netlink) {
				/*
				 * //console.log(netlinkToFilter)
				 *  let society_name = this.getSocietyName(netlinkToFilter.society_id)
				 */

				/*
				 * if(society_name != "") society_name = society_name.toLowerCase()
				 * //console.log("netlinkToFilter", netlinkToFilter)
				 */
				let netlinkSearchKeyList = {};

				let purchaseDate = netlinkToFilter.creation_date;
				let re = new RegExp("([T|Z])", "g");
				purchaseDate = purchaseDate ? purchaseDate.replace(re, " ") : null;
				purchaseDate = purchaseDate ? new Date(purchaseDate) : null;
				this.dateFromFilterOn
					? (netlinkSearchKeyList["dateFromFilter"] = purchaseDate)
					: false;
				this.dateToFilterOn
					? (netlinkSearchKeyList["dateToFilter"] = purchaseDate)
					: false;

				this.contractFilterOn
					? (netlinkSearchKeyList["contractFilter"] =
							netlinkToFilter.contract_id
								? netlinkToFilter.contract_id.toString()
								: "")
					: false;
				this.societyFilterOn
					? (netlinkSearchKeyList["societyFilter"] = netlinkToFilter.society_id)
					: false;
				this.anchorFilterOn
					? (netlinkSearchKeyList["anchorFilter"] = netlinkToFilter.anchor_type)
					: false;
				this.linkNameFilterOn
					? (netlinkSearchKeyList["linkNameFilter"] = [
							netlinkToFilter.url_bought,
							netlinkToFilter.landing_page,
					  ])
					: false;
				this.linkFilterOn
					? (netlinkSearchKeyList["linkFilter"] = netlinkToFilter.link_type)
					: false;
				this.providerFilterOn
					? (netlinkSearchKeyList["providerFilter"] =
							netlinkToFilter.provider_name.toLowerCase())
					: false;

				let check = true;

				for (let key in searchKeyList) {
					if (typeof searchKeyList[key] == "string") {
						if (typeof netlinkSearchKeyList[key] == "string") {
							if (!netlinkSearchKeyList[key].includes(searchKeyList[key])) {
								check = false;
								break;
							}
						} else if (typeof netlinkSearchKeyList[key] == "object") {
							//console.log("Array");
							let checkLoop = false;
							for (let row of netlinkSearchKeyList[key]) {
								if (row && row.includes(searchKeyList[key])) {
									//console.log("row", row, searchKeyList[key], row.includes(searchKeyList[key]));
									checkLoop = true;
									break;
								}
							}

							if (checkLoop) {
								check = true;
								break;
							} else {
								check = false;
							}
						}
					} else if (searchKeyList[key] instanceof Date) {
						if (key == "dateFromFilter") {
							// //console.log("dateFromFilter", searchKeyList[key].toISOString(), netlinkSearchKeyList[key].toISOString(), searchKeyList[key] <= netlinkSearchKeyList[key])
							check = searchKeyList[key] <= netlinkSearchKeyList[key];
						}
						if (key == "dateToFilter") {
							//console.log("dateToFilter", searchKeyList[key], netlinkSearchKeyList[key]);
							check = searchKeyList[key] >= netlinkSearchKeyList[key];
						}
						if (!check) break;
					} else {
						if (netlinkSearchKeyList[key] != searchKeyList[key] - 1) {
							check = false;
							break;
						}
					}
				}
				if (check) netlinkList.push(netlinkToFilter);
			}
			//return result

			let listId = [];
			for (let i = 0; i < netlinkList.length; i++) {
				listId.push(netlinkList[i]["id"]);
			}
			this.listNetlinksId = listId.toString();
			if (this.statusFilterOn)
				netlinkList = netlinkList.filter((netlink) =>
					this.statusFilter.includes(netlink.status)
				);
			//console.log(netlinkList);
			if (this.periodToFilterOn) {
				netlinkList = netlinkList.filter(
					(netlink) => netlink.period_date == this.periodToFilter
				);
			}
			return netlinkList;
		},

		displayContractPopup(contract) {
			this.$http
				.get(this.apiUrl + "contract/get/" + contract.toString())
				.then((res) => {
					//Initialisation des données pour le popup
					this.showContractPopup = true;
					let contractProp = res.data[0];
					contractProp.society_name = this.getSocietyName(
						contractProp.society_id
					);
					//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
					let ComponentClass = Vue.extend(ContractInfoPopup);
					let contractPopup = new ComponentClass({
						propsData: {
							contract: res.data[0],
							popupActive: this.showContractPopup,
							router: this.$router,
							apiUrl: this.apiUrl,
						},
					});
					contractPopup.$mount();
					this.$refs.popupContainer.appendChild(contractPopup.$el);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		displaySocietyPopup(society) {
			//Initialisation des données pour le popup
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = society;
			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		/**
		 * Return list of societies to display
		 * @return {List} - societies to display
		 */
		displayNetlink(netlink) {
			//////console.log("displayNetlink BEGIN")
			let netlinkList = [];
			if (this.displayedNetlink.length > 0) {
				netlinkList = this.displayedNetlink;
			} else {
				if (!this.isFilterSet()) {
					netlinkList = netlink;
				}
			}
			return netlinkList;
		},
		gestionFilterReq() {
			try {
				let today = new Date(Date.now());
				let startDate = this.filterFields
					? this.filterFields.start_date.split("/").reverse().join("-")
					: today.toISOString().substring(0, 7);
				this.cloneListContracts = [];
				if (
					this.listContracts &&
					!Object.keys(this.listContracts).includes(startDate)
				) {
					this.refreshKey++;
					return;
				}
				let listContractsEntries = this.listContracts
					? Object.entries(this.listContracts[startDate])
					: [];
				let copyCloneList =
					listContractsEntries.length > 0
						? listContractsEntries.map((row) => row[1])
						: [];
				this.cloneListContracts = this.filterList(
					"GESTION_NETLINKING_FILTER",
					copyCloneList
				);
				this.refreshKey++;
			} catch (e) {
				console.error(e);
			}
		},

		searchAndDisplay() {
			this.isNetlinkLoading = true;
			this.displayedNetlink = this.filterNetlink(this.displayedNetlinkFull); //A CHANGER
			this.isNetlinkLoading = false;
			// this.filterContract();
		},

		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = "";
			switch (name) {
				case "price":
					value ? (value = String(val)) : "";
					constname = "priceConstraint";
					break;
				case "url_bought":
				case "landing_page":
					constname = "websiteConstraint";
					break;
				default:
					value ? (value = String(val)) : "";
					value == null ? (value = "") : "";
					constname = "isNumberConstraint";
					break;
			}
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			val == null ? this.validators[name].valid == false : "";
			this.validators[name].valid == false &&
			this.validators[name].errText == ""
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				return "display: inline-block; border: 1px solid red !important; border-radius: 5px; width: calc(100% - 30px) !important;";
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				return "display: inline-block; border: 1px solid green !important; border-radius: 5px;";
			} else {
				return "display: inline-block; border: none !important; border-radius: none;";
			}
		},

		saveModifiedNetlink() {
			this.check = true;
			let fields = [
				"url_bought",
				"landing_page",
				"status",
				"anchor_type",
				"link_type",
				"price",
				"renew_duration",
				"period_date",
			];
			let constname = "";

			for (let i = 0; i < fields.length; i++) {
				if (fields[i] != "period_date") {
					let value = this.modifiedNetlink[fields[i]];
					value == 0 ? (value = "0") : "";
					switch (fields[i]) {
						case "url_bought":
						case "landing_page":
							constname = "websiteConstraint";
							break;
						case "price":
							value ? (value = String(value)) : "";
							constname = "priceConstraint";
							break;
						default:
							value ? (value = String(value)) : "";
							value == null ? (value = "") : "";
							constname = "isNumberConstraint";
							break;
					}
					this.validators[fields[i]] = new Validator({
						constraintName: constname,
					});
					this.validators[fields[i]].check(value);
					this.modifiedNetlink[fields[i]] == null
						? (this.validators[fields[i]].valid = false)
						: "";
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
						? (this.validators[fields[i]].errText =
								"Ce champ ne peut être vide.")
						: "";
					if (
						fields[i] == "renew_duration" &&
						!this.isRecurringLink(this.modifiedNetlink.link_type)
					) {
						this.modifiedNetlink.renew_duration = null;
						this.validators[fields[i]].valid = true;
					}
					if (this.isFromNDD == 1) {
						if (
							fields[i] == "renew_duration" ||
							fields[i] == "link_type" ||
							fields[i] == "price"
						) {
							this.modifiedNetlink.renew_duration = null;
							this.modifiedNetlink.link_type = null;
							this.modifiedNetlink.price = null;
							this.validators[fields[i]].valid = true;
						}
					}
					if (this.isFromNDD == 0) {
						if (fields[i] == "newNetlinkDns") {
							this.newNetlinkDns = null;
							this.validators[fields[i]].valid = true;
						}
					}
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText !== ""
						? (this.check = false)
						: "";
				}
			}

			// this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.modifiedNetlink.price = String(this.modifiedNetlink.price).replace(
					",",
					"."
				);
				this.modifiedNetlink.price = Number(this.modifiedNetlink.price);

				let re = new RegExp("([T|Z])", "g");
				this.modifiedNetlink.creation_date =
					this.modifiedNetlink.creation_date.replace(re, " ");

				let params = {
					id: this.modifiedNetlink.id,
					urlBought: this.modifiedNetlink.url_bought,
					anchorType: this.modifiedNetlink.anchor_type,
					landingPage: this.modifiedNetlink.landing_page,
					status: this.modifiedNetlink.status,
					linkType: this.modifiedNetlink.link_type,
					domainAuthority: this.modifiedNetlink.domain_authority,
					pageAuthority: this.modifiedNetlink.page_authority,
					trustFlow: this.modifiedNetlink.trust_flow,
					citationFlow: this.modifiedNetlink.citation_flow,
					externalLinks: this.modifiedNetlink.external_links,
					refDomains: this.modifiedNetlink.ref_domains,
					purchase_id: this.modifiedNetlink.purchase_id,
					society_id: this.modifiedNetlink.society_id,
					creation_date: this.modifiedNetlink.creation_date,
					recurring_purchase_id: this.modifiedNetlink.recurring_purchase_id,
					dns_id: this.modifiedNetlink.dns_id,
					contract_id: this.modifiedNetlink.contract_id,
					price: this.modifiedNetlink.price,
					renew_duration: this.modifiedNetlink.renew_duration,
					renew_date: this.modifiedNetlink.renew_date,
					provider_id: this.modifiedNetlink.provider_id,
					period_date: this.modifiedNetlink.period_date || null,
					editMain: true,
				};
				/*
				 * //console.log("params")
				 * //console.log(params)
				 */
				let savedModifiedNetlink = new Netlink(params);
				savedModifiedNetlink.update((err, res) => {
					if (res) {
						//console.log(err);
						this.$vs.notify({
							title: "Succès",
							text: "Netlink modifié avec succès.",
						});
						this.getAllNetlink();
						this.getAllNetlinkTypes();
						this.netlinkRefreshKey++;

						this.showNetlinkPopup = false;
						// //console.log(res);
						////console.log(this.netlink)
					} else {
						this.$vs.notify({
							title: "Echec",
							text: "Erreur lors de la modification du netlink.",
							color: "danger",
						});
					}
				});
				// this.searchAndDisplay();
			}
		},

		transData() {
			this.filterContract();
		},

		async filterContract() {
			try {
				this.isGestionLoading = true;
				this.$store.dispatch("getAllNetlink");
				this.$http
					.get(this.apiUrl + "account_manager_view/contract/netlinking/all")
					.then(async (res) => {
						/*
						 * let tmp = JSON.parse(JSON.stringify(res.data));
						 * //console.log("tmp_netlink", tmp);
						 * let list = [];
						 * for(let row of tmp){
						 * 	if(!list[row.period_date.substring(0, 7)]) list[row.period_date.substring(0, 7)] = [];
						 * 	list[row.period_date.substring(0, 7)].push(row);
						 * }
						 */

						// let finalList = [];

						/*
						 * for(let row of Object.entries(list)){
						 * 	row[1].forEach((cur) => {
						 * 		if(!row[1]["x" + cur.contract_id]){
						 * 			row[1]["x" + cur.contract_id] = [];
						 * 			row[1]["x" + cur.contract_id]["data"] = [];
						 * 		}
						 * 		row[1]["x" + cur.contract_id].data.push(cur);
						 * 	});
						 * 	if(!row[1][0]["x" + row[1][0].contract_id]){
						 * 		row[1][0]["x" + row[1][0].contract_id] = [];
						 * 		row[1][0]["x" + row[1][0].contract_id]["data"] = [];
						 * 	}
						 * 	row[1][0]["x" + row[1][0].contract_id].data.push({
						 * 		contract_id: row[1][0].contract_id,
						 * 		mission_id: row[1][0].mission_id,
						 * 		netlink_id: row[1][0].netlink_id,
						 * 		period_date: row[1][0].period_date,
						 * 		price: row[1][0].price,
						 * 		purchase_id: row[1][0].purchase_id,
						 * 	});
						 * 	row[1] = Object.values(row[1]).filter(r => Array.isArray(r));
						 * 	for(let c of row[1]){
						 * 		let data = JSON.parse(JSON.stringify(c.data));
						 * 		c = this.contracts.find(contract => contract.id == data[0].contract_id);
						 * 		if(!c){
						 * 			//console.log("Contract not found", data[0].contract_id, this.contracts);
						 * 			continue;
						 * 		}
						 * 		c["delivery_name"] = this.products_categories.find(pc => pc.id == c.delivery).name;
						 * 		c["missions"] = [];
						 * 		c.missions = this.missions.filter(m => m.contract_id == c.id && this.products.find(p => p.id == m.products_id && p.sub_category == 7));
						 * 		for(let m of c.missions){
						 * 			m["addMode"] = false;
						 * 			m["url_bought"] = null;
						 * 			m["landing_page"] = null;
						 * 			m["netlink_price"] = 0;
						 * 			m["sell_price"] = 0;
						 * 			m["is_billable"] = null;
						 * 			m["renew_duration"] = null;
						 * 			m["period_date"] = null;
						 * 			m["netlink_status"] = null;
						 * 			m["provider_id"] = null;
						 * 			m["anchor_type"] = null;
						 * 			m["link_type"] = null;
						 * 			m["netlinks"] = [];
						 * 			m["mission_spent_budget_netlink"] = 0;
						 * 			let ifNetlinks = data.filter(pn => pn.mission_id == m.id);
						 * 			if(ifNetlinks.length > 0){
						 * 				let netlinkIdList = Array.from(ifNetlinks, ({netlink_id}) => netlink_id);
						 * 				m.netlinks = [...this.netlink.filter(n => netlinkIdList.includes(n.id))];
						 * 				for(let n of m.netlinks){
						 * 					n["netlink_price"] = ifNetlinks.find(pn => pn.netlink_id == n.id).price;
						 * 					n["purchase_id"] = ifNetlinks.find(pn => pn.netlink_id == n.id).purchase_id;
						 * 					m.mission_spent_budget_netlink += n.netlink_price;
						 * 				}
						 * 			}
						 * 			// PERF
						 * 			m["tasks"] = netlinkTasks.data.filter(task => task.mission_id == m.id);
						 * 			// await this.$http.get(this.apiUrl + "task/getMissionTasks/"+ m.id).then(async(res) => {
						 * 			// 	m["tasks"] = res.data;
						 * 			// });
						 * 		}
						 * 		// PERF
						 * 		c["tags"] = [];
						 * 		// await this.$http.get(this.apiUrl + "tags/society/"+ c.society_id).then(async(res) => {
						 * 		// 	c["tags"] = res.data;
						 * 		// });
						 */

						/*
						 * 		if(!finalList[row[0]]) finalList[row[0]] = [];
						 * 		finalList[row[0]].push(c);
						 * 	}
						 * }
						 * //console.log("finalList", finalList);
						 */
						//console.log(res.data);
						this.listContracts = res.data;
						//console.log("this.filterFields.start_date", this.filterFields.start_date);
						let today = new Date(Date.now());
						let startDate = this.filterFields
							? this.filterFields.start_date.split("/").reverse().join("-")
							: today.toISOString().substring(0, 7);
						this.cloneListContracts = [];
						if (
							this.listContracts &&
							!Object.keys(this.listContracts).includes(startDate)
						) {
							this.refreshKey++;
							return;
						}
						let listContractsEntries = this.listContracts
							? Object.entries(this.listContracts[startDate])
							: [];
						this.cloneListContracts =
							listContractsEntries.length > 0
								? listContractsEntries.map((row) => row[1])
								: [];

						this.refreshKey++;
					});
				this.isGestionLoading = false;
			} catch (e) {
				console.error(e);
				this.isGestionLoading = false;
			}
		},
		async getAllAccountManagerContracts() {
			await this.$http
				.get(this.apiUrl + "account_manager_view/contract/netlinking/all")
				.then(async (res) => {
					this.allContracts = res.data;
					//console.log("allcontrat", this.allContracts);

					await this.filterContract();
				})
				.catch((err) => {
					//console.log(err);
				});
		},

		getNetlinkTypeName(netlinkTypeId) {
			let foundNetlinkType = this.netlink_types.findIndex(
				(row) => row.id == netlinkTypeId
			);
			if (foundNetlinkType >= 0)
				return this.netlink_types[foundNetlinkType].name;
			else " ";
		},

		exportData(dataIn) {
			let data = [];
			if (dataIn == "tabGestion") {
				for (let c of this.cloneListContracts) {
					for (let m of c.missions) {
						if (m.netlinks && m.netlinks.length > 0) {
							for (let n of m.netlinks) {
								n["contract_id"] = c.contract_id;
								n["society_name"] = c.society_name;
								n["mission_name"] = m.name;
								n["provider_name"] = this.getProviderName(n.provider_id);
								n.status = this.getNetlinkStatus(n.status);
								n.link_type = this.getNetlinkTypeName(n.link_type);
								n.anchor_type = this.getNetlinkAnchorType(n.anchor_type);
								n.creation_date = this.dateToFR(n.creation_date);
								delete n.provider_id;
								data.push(n);
							}
						}
					}
				}

				let wb = XLSX.utils.book_new();
				let ws_name = "Netlink";

				let header = {
					header: [
						"id",
						"society_name",
						"contract_id",
						"mission_name",
						"link_type",
						"anchor_type",
						"url_bought",
						"landing_page",
						"provider_name",
						"creation_date",
						"netlink_price",
						"status",
						"purchase_id",
					],
					skipHeader: true,
					origin: -1,
				};

				let header_names = [
					{
						id: "Identifiant netlink",
						society_name: "Société",
						contract_id: "Numéro de contrat",
						mission_name: "Prestation",
						link_type: "Type lien",
						anchor_type: "Type ancre",
						url_bought: "Lien acheté",
						landing_page: "Landing Page",
						provider_name: "Prestataire",
						creation_date: "Date de création/achat",
						netlink_price: "Prix",
						status: "Statut",
						purchase_id: "Identifiant achat",
					},
				];
				let ws = XLSX.utils.json_to_sheet(header_names, header);
				XLSX.utils.sheet_add_json(ws, data, header);

				/* Add the worksheet to the workbook */
				XLSX.utils.book_append_sheet(wb, ws, ws_name);

				XLSX.writeFile(wb, "Netlinks_export.xls");
			} else {
				data = JSON.parse(JSON.stringify(dataIn));

				for (let i = 0; i < data.length; i++) {
					data[i]["status"] = this.getNetlinkStatus(data[i]["status"]);
					data[i]["link_type"] = this.getNetlinkTypeName(data[i]["link_type"]);
					data[i]["anchor_type"] = this.getNetlinkAnchorType(
						data[i]["anchor_type"]
					);
					data[i]["society_id"] = this.research(
						data[i]["society_id"],
						this.societies,
						"id",
						"name"
					);
					data[i]["creation_date"] = this.dateToFR(data[i]["creation_date"]);

					for (let x in data[i]) {
						data[i][x] = String(data[i][x]).trim();
					}

					this.$delete(data[i], "dns_id");
					this.$delete(data[i], "provider_id");
					this.$delete(data[i], "renew_date");
					this.$delete(data[i], "renew_duration");
				}

				let wb = XLSX.utils.book_new();
				let ws_name = "Netlink";

				let header = {
					header: [
						"id",
						"society_id",
						"contract_id",
						"link_type",
						"anchor_type",
						"url_bought",
						"landing_page",
						"provider_name",
						"creation_date",
						"price",
						"status",
						"domain_authority",
						"page_authority",
						"ref_domains",
						"external_links",
						"trust_flow",
						"citation_flow",
						"purchase_id",
						"recurring_purchase_id",
					],
					skipHeader: true,
					origin: -1,
				};

				let header_names = [
					{
						id: "Identifiant",
						society_id: "Identifiant société",
						contract_id: "Numéro de contrat",
						link_type: "Type lien",
						anchor_type: "Type ancre",
						url_bought: "Lien acheté",
						landing_page: "Landing Page",
						provider_name: "Prestataire",
						creation_date: "Date de création/achat",
						price: "Prix",
						status: "Statut",
						domain_authority: "Domain authority",
						page_authority: "Page authority",
						ref_domains: "Domaines référents",
						external_links: "External links",
						trust_flow: "Trust flow",
						citation_flow: "Citation flow",
						purchase_id: "Identifiant achat",
						recurring_purchase_id: "Identifiant achat récurrent",
					},
				];
				let ws = XLSX.utils.json_to_sheet(header_names, header);
				XLSX.utils.sheet_add_json(ws, data, header);

				/* Add the worksheet to the workbook */
				XLSX.utils.book_append_sheet(wb, ws, ws_name);

				XLSX.writeFile(wb, "Netlinks_export.xls");
			}
		},
	},
};
</script>
<style lang="scss">
.btn {
	background-color: white !important;
	border: none;
	border: 1px solid #08b0b9 !important;
	color: #08b0b9;
	padding: 12px 12px;

	cursor: pointer;
}
.btn:hover {
	box-shadow: 0px 15px 20px rgba(255, 255, 255, 0.945) !important;
}
.con-tablex.vs-table--content {
	overflow-x: auto;
}
.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
</style>